import { useCallback, useEffect, useRef, useState } from "react";
import { useParams, useLocation } from "react-router";
import { getApi, putApi } from "../../services/api/globalApi";
import { convertDate } from "../../utils/convertDate";
import { digitsThree } from "../../utils/price";
import { formatWeight } from "../../utils/formatWeight";
import { Link } from "react-router-dom";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { useSelector } from "react-redux";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import Select from "../../components/common/inputs/Select";
import SingleOrderCard from "./sub-components/single-order/SingleOrderCard";
import EditOrderModal from "./sub-components/edit-order-modal/EditOrderModal";
import RejectOrderModal from "./sub-components/reject-order-modal/RejectOrderModal";

function ShowSingleOrder() {
  const { utils } = useSelector(utilsState);
  const location = useLocation();

  const [data, setData] = useState(null);
  const { id } = useParams();
  const isSaboraOrder = location.pathname.includes("sabora");
  const orderListPath = isSaboraOrder ? "/sabora-order-list" : "/order-list";

  const getSingleOrder = useCallback(async () => {
    const path = `admin/orders/${id}`;
    try {
      const data = await getApi({ path });
      console.log(data);
      setData(data.data.result);
      setProccessShipping(data.data.result.proccessShipping);
    } catch (error) {}
  }, [id]);

  useEffect(() => {
    getSingleOrder();
  }, [getSingleOrder]);

  const editRef = useRef();

  const [proccessShipping, setProccessShipping] = useState("");

  const changeProccess = async () => {
    const path = `admin/orders/${data?._id}/proccessShipping`;
    const body = {
      proccessShipping,
    };
    try {
      await putApi({ path, body });
      successMessage("وضعیت سفارش با موفقیت تغییر داده شد");
    } catch (error) {
      console.log(error);
      errorMessage(error?.response?.data?.errors[0]?.message);
    }
  };

  const rejectRef = useRef();

  const totalWeight = data?.products?.reduce((sum, item) => {
    let weight = item.product?.weight || 0;
    if (item.productVarSku && item.product?.option?.variations?.length) {
      const variation = item.product.option.variations.find(
        (v) => v.sku === item.productVarSku
      );
      if (variation?.weight !== undefined) weight = variation.weight;
    }
    return sum + weight * (item.count || 0);
  }, 0);

  return (
    <>
      <EditOrderModal
        ref={editRef}
        productData={data}
        reGetData={getSingleOrder}
      />
      <RejectOrderModal ref={rejectRef} orderData={data} />

      <div className="w-full max-w-7xl px-4 md:px-5 lg-6 mx-auto py-4">
        <div className="main-box bg-white dark:bg-gray-800 rounded-3xl  border border-gray-200 rounded-xl max-w-xl max-lg:mx-auto lg:max-w-full">
          <div className="flex flex-col sm:flex-row w-full my-3 px-3 sm:items-center justify-between dark:text-white gap-3">
            <h3 className="font-bold text-lg text-right">مشخصات سفارش :</h3>
            <div className="flex items-center justify-center gap-2 flex-wrap">
              {data?.paymentStatus === "done" &&
              data?.proccessShipping === "awaitingAccepted" ? (
                <button
                  onClick={() => rejectRef.current.showModal()}
                  type="button"
                  className="text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-xs sm:text-sm px-3 sm:px-5 py-2 sm:py-2.5 dark:bg-red-600 dark:hover:bg-red-700 focus:outline-none dark:focus:ring-red-800"
                >
                  لغو
                </button>
              ) : null}
              <button
                onClick={() => editRef.current.showModal()}
                type="button"
                className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-xs sm:text-sm px-3 sm:px-5 py-2 sm:py-2.5 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
              >
                ویرایش
              </button>
              <Link to={orderListPath}>
                <button
                  type="button"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-xs sm:text-sm px-3 sm:px-5 py-2 sm:py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  لیست سفارشات
                </button>
              </Link>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center gap-2 pb-6 border-b border-gray-400 px-6 dark:text-white">
            <p className="text-right">وضعیت :</p>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
              <Select
                value={proccessShipping}
                onChange={(e) => setProccessShipping(e.target.value)}
                useFormik={false}
                className="bg-white text-center sm:text-right"
              >
                {utils?.ORDER_PROCCESS_SHIPPING_STATUS_VALUES?.map((item) => {
                  return (
                    <option key={item.value} value={item?.value}>
                      {item?.name}
                    </option>
                  );
                })}
              </Select>
              <button
                onClick={() => changeProccess()}
                type="button"
                className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-green-600 dark:hover:bg-green-700 focus:outline-none dark:focus:ring-green-800"
              >
                تغییر وضعیت
              </button>
            </div>
          </div>

          <h3 className="my-3 px-3 font-bold text-lg dark:text-white">
            مشخصات کاربر :
          </h3>
          <div className="flex flex-col gap-6 pb-6 border-b border-gray-400 px-6 ">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  نام:{" "}
                  <span className="text-indigo-600 font-medium">
                    {" "}
                    {data?.user.name}
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black  dark:text-white mt-4">
                  موبایل :{" "}
                  <span className="text-gray-400 dark:text-gray-100 font-medium">
                    {" "}
                    {data?.user.mobile}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  شماره سفارش:{" "}
                  <span className="text-indigo-600 font-medium">
                    #{data?.trackingCode}
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black  dark:text-white mt-4">
                  تاریخ :{" "}
                  <span className="text-gray-400 dark:text-gray-100 font-medium">
                    {" "}
                    {convertDate(data?.createdAt)}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  مبلغ کل:{" "}
                  <span className="text-indigo-600 font-medium">
                    {digitsThree(data?.totalPrice)} تومان
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black  dark:text-white mt-4">
                  مبلغ پرداخت شده:{" "}
                  <span className="text-gray-400 dark:text-gray-100 font-medium">
                    {" "}
                    {digitsThree(data?.finalPrice)} تومان
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  تخفیف:{" "}
                  <span className="text-indigo-600 font-medium">
                    {digitsThree(data?.totalDiscount)} تومان
                  </span>
                </p>
                <p className="font-semibold text-base leading-7 text-black  dark:text-white mt-4">
                  هزینه حمل و نقل:{" "}
                  <span className="text-gray-400 dark:text-gray-100 font-medium">
                    {" "}
                    {digitsThree(data?.shippingFinalPrice)} تومان
                  </span>
                </p>
              </div>
            </div>
            {totalWeight > 0 ? (
              <div className="flex flex-col lg:flex-row lg:items-center justify-between">
                <div className="data w-full">
                  <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                    مجموع وزن محصولات:{" "}
                    <span className="text-indigo-600 font-medium">
                      {formatWeight(totalWeight)}
                    </span>
                  </p>
                </div>
              </div>
            ) : null}
          </div>

          <h3 className="my-3 px-3 font-bold text-lg  dark:text-white">
            مشخصات تحویل گیرنده :
          </h3>
          <div className="flex flex-col gap-6 pb-6 border-b border-gray-400 px-6 ">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  نام :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.name || "-"}{" "}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  موبایل :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.mobile || "-"}{" "}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  آدرس :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.address || "-"}{" "}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  استان:{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.province}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row lg:items-center justify-between">
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  شهر :{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.city}
                  </span>
                </p>
              </div>
              <div className="data w-full">
                <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                  کد پستی:{" "}
                  <span className="text-indigo-600 font-medium">
                    {data?.postcode || "-"}
                  </span>
                </p>
              </div>
            </div>
            <div className="data w-full">
              <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                توضیحات:{" "}
                <span className="text-indigo-600 font-medium">
                  {data?.description || "-"}
                </span>
              </p>
            </div>
            <div className="data w-full">
              <p className="font-semibold text-base leading-7 text-black  dark:text-white">
                بارکد:{" "}
                <span className="text-indigo-600 font-medium">
                  {data?.barcode || "-"}
                </span>
              </p>
            </div>
          </div>

          <h3 className="my-3 px-3 font-bold text-lg dark:text-white">
            شرح کالا :
          </h3>
          <div className="w-full px-3 min-[400px]:px-6">
            {data?.products.length > 0 &&
              data?.products.map((item, index) => {
                return <SingleOrderCard key={index} data={item} />;
              })}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShowSingleOrder;
